import React, { useState } from 'react';
import './official.css';
import letterimg from '../../images/import.jfif';

function Official() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageSelected = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const handleCloseImage = () => {
    setSelectedImage(null);
  };

  return (
    <div className='official-container'>
      <h1>الموافقات الرسمية</h1>
      <hr className='official-hr' />
      <div className='official-content'>
        <img
          src={letterimg}
          alt="Letter"
          onClick={() => handleImageSelected(letterimg)}
        />
      </div>
      {selectedImage && (
        <div className='poppedimg' onClick={handleCloseImage}>
          <img src={selectedImage} alt="Selected" />
          <button className='close-button' onClick={handleCloseImage}></button>
        </div>
      )}
    </div>
  );
}

export default Official;
